import { render } from "./MenuComponent.vue?vue&type=template&id=2c02fc61&scoped=true"
import script from "./MenuComponent.vue?vue&type=script&lang=ts"
export * from "./MenuComponent.vue?vue&type=script&lang=ts"

import "./MenuComponent.vue?vue&type=style&index=0&id=2c02fc61&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2c02fc61"

export default script